// Import our Bootstrap extensions
import "bootstrap/dist/js/bootstrap.bundle";
import Prism from 'prismjs';
import './prismjs-languages';

import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import bsBundle from "bootstrap/dist/js/bootstrap.bundle";
import baguetteBox from 'baguettebox.js';


Prism.highlightAll();
window.Alpine = Alpine;
Alpine.plugin( persist );
baguetteBox.run( '.gallery' );

document.addEventListener('alpine:init', () => {
    // Data and methods to the event page
    Alpine.data('utils', ( eventData, isLatest, allowFilters ) => ({
        items: eventData,
        latest : isLatest,
        hasFilters : allowFilters,

        titleFilter: '',
        countrySelected: '',
        dateFilter: '',
        
        countryArray: function() {
            return this.items.reduce((values, item) => {
                item.customFields.forEach(field => {
                    if (field.key === 'country' && !values.includes(field.value)) {
                        values.push(field.value);
                    }
                });
                return values;
            }, []).sort()
        },

        getCustomField: function( obj, fieldName ) {
            let field = obj.customFields.find( ( field ) => field.key === fieldName );
            return field != undefined ? field.value : '';
        },

        displayDate: function( obj ){
            var date1 = this.getCustomField( obj, 'startDate' );
            var date2 = this.getCustomField( obj, 'endDate' );

            var startDate = new Date( date1 );
            var endDate   = new Date( date2 );

            var monthNames = [
                'Jan', 'Feb', 'Mar',
                'Apr', 'May', 'Jun', 
                'Jul', 'Aug', 'Sep', 
                'Oct', 'Nov', 'Dec'
            ];
    
            if( ( startDate.getDate() === endDate.getDate() && startDate.getMonth() === endDate.getMonth() ) || isNaN( endDate ) ){
                return date1;
            }else {
                if( startDate.getMonth() === endDate.getMonth() ){
                    return monthNames[ startDate.getMonth() ] + ' ' + startDate.getDate() + '-' + endDate.getDate()  + ' ' + startDate.getFullYear();  
                }else{
                    return date1 + ' to ' + date2;
                }
            }

            return date1;
        },

        formatDate: function( stringDate ){
            if( stringDate.length ){
                
                const date = new Date( stringDate );
                date.setHours(0,0,0,0);

                return date;
            }
            return '';
        },

        get filteredItems() {
            return this.items
                .filter(  item => {
                    if ( this.titleFilter.length ){
                        return item.title.toLowerCase().trim().includes( this.titleFilter.toLowerCase().trim() );
                    }
                    return true;
                } )
                .filter(  item => {
                    if ( this.countrySelected.length ){
                        return item.customFields.reduce( ( acc, customField ) => {
                            if ( customField.key == 'country' ) {
                                acc = customField.value;
                            }
                            return acc;
                        }, '' ) == this.countrySelected;
                    }
                    return true;
                } )
                .filter(  item => {
                    if ( this.dateFilter.length ){
                        
                        var date1 = item.customFields.reduce( ( acc, customField ) => {
                            if ( customField.key == 'startDate' ) { acc = customField.value; }
                            return acc;
                        }, '' );

                        var date2 = item.customFields.reduce( ( acc, customField ) => {
                            if ( customField.key == 'endDate' ) { acc = customField.value; }
                            return acc;
                        }, '' );

                        var startDate = new Date( date1 );
                        startDate.setHours(0,0,0,0);

                        var endDate = new Date( date2 );
                        endDate.setHours(0,0,0,0);
                        
                        var selectedDate = new Date( this.dateFilter );
                        selectedDate.setDate( selectedDate.getDate() + 1 );
                        selectedDate.setHours(0,0,0,0);


                        if( !isNaN( endDate ) && ( selectedDate >= startDate && selectedDate <= endDate ) ){
                            return true;
                        }

                        if( isNaN( endDate ) && selectedDate === startDate ){
                            return true;
                        }

                        return false;
                    }
                    return true;
                } ) ;
        }
    }));

    // General data of the site
    Alpine.data( 'generalData', function () {
        return {
            isDark: this.$persist( true ).as( 'luismajano-darkmode' ),
            isOpenMenu: false,
            categorySelected: this.$persist( "all" ).as( 'category-selected' ),
            currentPage: this.$persist( "1" ).as( 'currentPage' ),

            setCategorySelected( category ){
                this.categorySelected = category;
                this.currentPage = 1;

                window.location.href = category == "all" ? "/blog" : "/blog/category/" + category;

            },

            setCurrentPage( numberPage ){
                this.currentPage = numberPage;
                window.location.href = window.location.href.split('?')[0] + "?page=" + numberPage
            },

            updateOgImage( newImageUrl ){
                let ogImageMetaTag = document.querySelector( 'meta[property="og:image"]' );

                if (ogImageMetaTag) {
                    ogImageMetaTag.setAttribute('content', window.location.origin + newImageUrl);
                } else {
                    // If the og:image meta tag does not exist, create it
                    ogImageMetaTag = document.createElement( 'meta' );
                    ogImageMetaTag.setAttribute( 'property', 'og:image' );
                    ogImageMetaTag.setAttribute( 'content', window.location.origin + newImageUrl );
                    document.head.appendChild( ogImageMetaTag );
                }
            }
        }
    });
});

Alpine.start();


document.querySelector( ".blog-link" ).setAttribute( "x-on:click", "setCategorySelected( 'all' )" );

document.addEventListener('DOMContentLoaded', function() {

    // Update the entries styles
    recentEntriesClasses();

    function recentEntriesClasses(){
        if( document.getElementById( "recentEntries" ) ){
            let recentEntries = document.getElementById( "recentEntries" );
            recentEntries.style.paddingLeft = "0px";
    
            let li_list = recentEntries.getElementsByTagName( "li" );
            for (let item of li_list) {
                item.classList.add( "lh-1" );
            }
    
            let a_list = recentEntries.getElementsByTagName( "a" );
            for (let item of a_list) {
                item.classList.add( "text-white-50", "fs-6", "text-decoration-none" );
            }
        }
    }

    var tooltipTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="tooltip"]' ) )
    var tooltipList = tooltipTriggerList.map( function ( tooltipTriggerEl ) {
      return new bsBundle.Tooltip( tooltipTriggerEl )
    });
} );

if( document.querySelector('.dropdown-categories') ){
    const dropdownMenu = document.querySelector('.dropdown-categories');
    const searchInput = document.querySelector('.dropdown-search');
    
    searchInput.addEventListener('input', function() {
        const searchText = this.value.trim().toLowerCase();
    
        const items = dropdownMenu.querySelectorAll('.item-category');
    
        items.forEach(item => {
            const text = item.textContent.trim().toLowerCase();
            const isVisible = text.includes(searchText);

            item.style.display = isVisible ? 'block' : 'none';
        });
    });
}

if( document.getElementById('filterCategoryInput') ){
    // Get the input field and its value
    var searchInput = document.getElementById('filterCategoryInput');

    searchInput.addEventListener('input', function() {
        const searchText = this.value.trim().toLowerCase();
    
        // Get the container and all item divs
        var container = document.getElementById('categoryItemsContainer');
        const items = container.querySelectorAll('.category-item');
    
        items.forEach(item => {
            const text = item.textContent.trim().toLowerCase();
            const isVisible = text.includes(searchText);

            item.parentNode.style.display = isVisible ? 'block' : 'none';
        });
    });
}